import { getCached } from '../components/common';

export const getAuthorization = () => {
  const token = getCached.token();
  return `Bearer ${token}`;
};
